module.exports = __webpack_public_path__ + "img/mc.8fb7d82c.svg";